
import moment from 'moment'
import {mesesArrayL as months,mesesArrayS as shortMonths} from '../helpers/const'

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function upDown(type,valor,a_valor,b_valor,c_valor)
{   
    switch(type)
    {
        case 0:
            return valor-c_valor>0?1:(valor-c_valor===0?0:-1)
            break
        case 1:
            return valor-b_valor>0?1:(valor-b_valor===0?0:-1)
            break
        case 2:
            return valor-a_valor>0?1:(valor-a_valor===0?0:-1)
            break
        default:
            return 0
            break
    }
}

function valDorM(day,value,year,month,vsMorD,isBack)
{
    let days = moment(year+"-"+month, "YYYY-MM").daysInMonth()
    let currentDay = Number(moment().format('D'))

    if(isBack)
    {
        const backMonth = (month-1)===0?12:(month-1)
        const backYear = (month-1)===0?(year-1):(year)
        days = moment(backYear+"-"+backMonth, "YYYY-MM").daysInMonth()
        if (currentDay>days)
        {
            currentDay = days 
        }
    }
    

    if (vsMorD===0)
    {
        return value;
    }

    switch(day)
    {
        case 1:
            return Math.floor((currentDay*value/days))
            break
        case 3:
            return Math.floor((value*currentDay)/days)
            break
        case 2:
        default:
            return value
            break
    }

}

export async function  formatData(result,year,month,type,vsMorD)
{
    let sections = []
    let headers = []
    let dumyHeader = []
    const currentDay = Number(moment().format('D'))
    const currentMonth = Number(moment().format('M'))
    const currentYear = Number(moment().format('YYYY'))

    let day = currentMonth===month&&currentYear===year&&vsMorD===1?currentDay+"/":""

    const backMonth = (month-1)===0?12:(month-1)
    const backYear = (month-1)===0?(year-1):(year)
    let  backDay = moment(backYear+"-"+backMonth, "YYYY-MM").daysInMonth()
    let  _bakDay = currentMonth===month&&currentYear===year&&vsMorD===1?currentDay+"/":""
    if (currentDay>backDay)
    {
        _bakDay = currentMonth===month&&currentYear===year&&vsMorD===1?backDay+"/":""
    }
    await sleep(1200);
    sections = result.reduce((sections, itemSection) => {
            
      const section = {id_seccion:itemSection.id_seccion,seccion:itemSection.seccion,filas:[]}
      
      if (!sections.some(item => item.id_seccion === itemSection.id_seccion)) {
       
        let filas = []
        filas = result.reduce((filas, itemFila) => {
              
           const fila = {id_fila:itemFila.id_fila,fila:itemFila.fila,nivel:itemFila.nivel,columnas:[],dia:itemFila.dia}
           if (itemFila.id_seccion === section.id_seccion)
           {
             if (!filas.some(item => item.id_fila === itemFila.id_fila))
             {
                 let columnas = []
                 columnas = result.reduce((columnas, itemColumna) => {

                    let a_valor = valDorM(itemColumna.dia,itemColumna.a_valor,year,month,vsMorD,false)
                    const columnaA = {
                        id_columna:itemColumna.id_columna,
                        columna:itemColumna.columna, 
                        valor:a_valor,
                        sub_valor:itemColumna.a_sub_valor,
                        prefijo:itemColumna.a_prefijo,
                        subfijo:itemColumna.a_subfijo,
                        prefijo_sub:itemColumna.a_prefijo_sub,
                        subfijo_sub:itemColumna.a_subfijo_sub,
                        tipo:2}

                    const columnaAV = {
                        id_columna:itemColumna.id_columna,
                        columna:itemColumna.columna, 
                        valor:itemColumna.valor-a_valor,
                        sub_valor:a_valor?100*(itemColumna.valor-a_valor)/a_valor:0,
                        prefijo:itemColumna.prefijo,
                        subfijo:itemColumna.subfijo,
                        prefijo_sub:"|",
                        subfijo_sub:"%",
                        tipo:2}

                    let b_valor = valDorM(itemColumna.dia,itemColumna.b_valor,year,month,vsMorD,true)
                    const columnaB = {
                        id_columna:itemColumna.id_columna,
                        columna:itemColumna.columna, 
                        valor:b_valor,
                        sub_valor:itemColumna.b_sub_valor,
                        prefijo:itemColumna.b_prefijo,
                        subfijo:itemColumna.b_subfijo,
                        prefijo_sub:itemColumna.b_prefijo_sub,
                        subfijo_sub:itemColumna.b_subfijo_sub,
                        tipo:2}

                    const columnaBV = {
                        id_columna:itemColumna.id_columna,
                        columna:itemColumna.columna, 
                        valor:itemColumna.valor-b_valor,
                        sub_valor:b_valor?100*(itemColumna.valor-b_valor)/b_valor:0,
                        prefijo:itemColumna.prefijo,
                        subfijo:itemColumna.subfijo,
                        prefijo_sub:"|",
                        subfijo_sub:"%",
                        tipo:2}

                    let c_valor = valDorM(itemColumna.dia,itemColumna.c_valor,year,month,vsMorD,false)
                    const columnaC = {
                        id_columna:itemColumna.id_columna,
                        columna:itemColumna.columna, 
                        valor:c_valor,
                        sub_valor:itemColumna.c_sub_valor,
                        prefijo:itemColumna.c_prefijo,
                        subfijo:itemColumna.c_subfijo,
                        prefijo_sub:itemColumna.c_prefijo_sub,
                        subfijo_sub:itemColumna.c_subfijo_sub,
                        tipo:2}

                    const columnaCV = {
                        id_columna:itemColumna.id_columna,
                        columna:itemColumna.columna, 
                        valor:itemColumna.valor-c_valor,
                        sub_valor:c_valor?100*(itemColumna.valor-c_valor)/c_valor:0,
                        prefijo:itemColumna.prefijo,
                        subfijo:itemColumna.subfijo,
                        prefijo_sub:"|",
                        subfijo_sub:"%",
                        tipo:2}

                     const columna = {
                        id_columna:itemColumna.id_columna,
                        columna:itemColumna.columna, 
                        valor:itemColumna.valor,
                        sub_valor:itemColumna.sub_valor,
                        prefijo:itemColumna.prefijo,
                        subfijo:itemColumna.subfijo,
                        prefijo_sub:itemColumna.prefijo_sub,
                        subfijo_sub:itemColumna.subfijo_sub,
                        tipo:1,
                        analisis:upDown(type,itemColumna.valor,a_valor,b_valor,c_valor)}

                    if (itemColumna.id_fila === fila.id_fila)
                    {    
                        columnas.push(columna)
                        columnas.push(columnaA)
                        columnas.push(columnaAV)
                        columnas.push(columnaB)
                        columnas.push(columnaBV)
                        columnas.push(columnaC)
                        columnas.push(columnaCV)


                        if (!dumyHeader.includes(itemColumna.columna))
                        { 
                            headers.push({id:itemColumna.id_columna,nombre:itemColumna.columna,tipo:1})
                            headers.push({id:itemColumna.id_columna,nombre:"Ppto.  "+day+shortMonths[month]+"/"+(year),tipo:2})
                            headers.push({id:itemColumna.id_columna,nombre:"Variación",tipo:2})
                            headers.push({id:itemColumna.id_columna,nombre:_bakDay+shortMonths[backMonth]+"/"+backYear,tipo:2})
                            headers.push({id:itemColumna.id_columna,nombre:"Variación",tipo:2})
                            headers.push({id:itemColumna.id_columna,nombre:day+shortMonths[month]+"/"+(year-1),tipo:2})
                            headers.push({id:itemColumna.id_columna,nombre:"Variación",tipo:2})
                            dumyHeader.push(itemColumna.columna)
                        }
                    }
                    return columnas
                }, [])

                fila.columnas = columnas
                filas.push(fila)
             }
             
           }

          return filas

          }, [])
         section.filas = filas
         sections.push(section)
      }
            return sections

        }, [])

     return Promise.resolve({result:sections,headers:headers});
}